export default __webpack_public_path__ + "static/media/don't-let-me-down.5f7b4a83.jpg";